import React from 'react';
import {useTranslation} from 'next-i18next';
import {FormControl, FormLabel, HStack, IconButton, Input} from '@tempo/core';
import {PenIcon} from '@tempo/icons';
import {MODAL_STATE} from '@deezer/next/features/Account/type';
import Tooltip from '@components/Tooltip';

type UserMailProps = {
	data: string;
	onModalOpen?: (state: MODAL_STATE) => void;
	isDisabled?: boolean;
	canUpdate?: boolean;
};

const UserMail = ({
	onModalOpen,
	isDisabled,
	canUpdate,
	data,
}: UserMailProps) => {
	const {t} = useTranslation('d4c');

	const handleOpen = () => onModalOpen && onModalOpen(MODAL_STATE.EDIT_EMAIL);

	return (
		<FormControl>
			<FormLabel>{t('usermanager_text_email_d4c-web')}</FormLabel>
			<HStack>
				<Input
					placeholder={t('usermanager_text_emailexample_d4c-web')}
					type="email"
					value={data}
					disabled={isDisabled}
				/>
				{!canUpdate ? (
					<Tooltip
						label={t('oktaautherrormessage_text_accountcantbeupdated_d4c-web')}
					>
						<IconButton
							variant="outline"
							aria-label={'edit email icon'}
							icon={<PenIcon />}
							disabled={!canUpdate}
						/>
					</Tooltip>
				) : (
					<IconButton
						variant="outline"
						aria-label={'edit email icon'}
						icon={<PenIcon />}
						onClick={handleOpen}
					/>
				)}
			</HStack>
		</FormControl>
	);
};

export default UserMail;
